module.exports = __webpack_public_path__ + "static/media/addon.65d95977.svg";